import * as React from "react";
import { Button } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

interface Props {
    task: TaskModel;
    creatingMeeting: boolean;
}

export const JoinVideoMeetingButton: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <a href={props.task.teamsMeetingLink} target="_blank" rel="noopener noreferrer">
            <Button
                className="video-meetings-join-button"
                color="purple"
                content="Join"
                icon="video"
                labelPosition="right"
                disabled={!props.task.teamsMeetingLink || props.creatingMeeting}
            />
        </a>
    );
};
